<template>
    <div>
        <div v-for="(item, index) in timeLineArr" :key="index" class="time-line-info">
            <div @click="timelineClick(item)" :class="[{ 'time-line-inline-active': activeId === item.id }, 'time-line-inline']">
                <span class="time-line-dot">{{ index + 1 }}</span>
                <span class="time-line-dot-text">{{ item.content }}</span>
            </div>
            <img v-if="!item.noImg" src="./../../../../../assets/images/line.png" alt="">
        </div>
    </div>
</template>


<script>
export default {
    name: "time-line",
    props: {
        activeId: null,
        timeLineArr: {
            type: Array,
            value: () => {
                return []
            }
        }
    },
    data() {
        return {
        }
    },
    methods: {
        timelineClick(item) {
            this.$emit('change', item)
        }
    }
}
</script>

<style lang="scss">
.time-line-info {
    font-size: 14px;

    .time-line-inline {
        line-height: 18px;
        cursor: pointer;
        .time-line-dot {
            display: inline-block;
            border: 1px solid #E4E5E6;
            border-radius: 50%;
            width: 18px;
            height: 18px;
            line-height: 18px;
            text-align: center;
            margin-right: 10px;
            color: #666666;
            font-size: 12px;
        }
    }

    img {
        display: inline-block;
        margin: 6px 10px;
    }

    .time-line-inline-active {
        .time-line-dot {
            background: #1F6EEF;
            color: #FFFFFF;
            border: 1px solid #1F6EEF;
        }
        .time-line-dot-text {
            color: #1F6EEF;
            font-weight: bold;
        }
    }
}
</style>